"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateChangePassword = exports.validateForgotPassword = undefined;

var _revalidate = require("revalidate");

var _emailValidator = require("email-validator");

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var validate = (0, _revalidate.combineValidators)({
  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)("Email"),

  password: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1))({
    message: "Must be 6 or more characters"
  })
});

exports.default = validate;


var validateForgotPassword = (0, _revalidate.combineValidators)({
  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)("Email")
});

var validateChangePassword = (0, _revalidate.combineValidators)({
  password: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1))("Password"),

  repeatPassword: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(6 - 1), (0, _revalidate.matchesField)("password")({
    message: "Passwords do not match"
  }))("Repeat Password")
});

exports.validateForgotPassword = validateForgotPassword;
exports.validateChangePassword = validateChangePassword;


//////////////////
// WEBPACK FOOTER
// ./src/utils/loginFormValidation.js
// module id = 572
// module chunks = 0